import { createContext } from 'react';
import { type IBusinessUnit } from '../services/businessCaseService';
import { type ISharePointFile } from '../services/sharepointService';

export interface BusinessCase {
    id: string;
    name: string;
    description: string;
    status: string;
    createdAt: Date;
    updatedAt: Date;
}

export interface BCTContextType {
    businessCases: BusinessCase[];
    selectedBusinessCase: BusinessCase | null;
    setSelectedBusinessCase: (bc: BusinessCase | null) => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
    businessUnits: IBusinessUnit[] | null;
    businessUnitsLoading: boolean;
    businessUnitsError: string | null;
    refreshBusinessUnits: () => Promise<void>;
    sharepointFiles: ISharePointFile[] ;
    sharepointFilesLoading: boolean;
    sharepointFilesError: string | null;
    refreshSharepointFiles: () => Promise<void>;
    initializeData: () => Promise<void>;
    isInitialized: boolean;
}

export const BCTContext = createContext<BCTContextType | undefined>(undefined);